module.exports = __webpack_public_path__ + "static/media/brain.a963660c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon/brain.svg
// module id = 1248
// module chunks = 0